$(->
  activate_days_to_fill = ->
    hire_date = moment $('#days_to_fill_hire').val()

    $('#days_to_fill_open').on 'click', ->
      modal = $('#outside_days_to_fill_modal')
      modal.remove() if modal.length > 0
      modal = $('<div id="outside_days_to_fill_modal" class="modal"></div>').appendTo('body')

      modal.html $('#days_to_fill_modal').html()
      p = modal.find '#days_to_fill_start_date'
      p.datetimepicker
        inline: true
        format: 'YYYY-MM-DD'
        maxDate: hire_date
        icons:
          time: "fa fa-clock-o"
          date: "fa fa-calendar"
          up: "fa fa-arrow-up"
          down: "fa fa-arrow-down"
          previous: 'fa fa-chevron-left'
          next: 'fa fa-chevron-right'
          today: 'fa fa-desktop'
          clear: 'fa fa-trash',
          close: 'fa fa-times'

      p.data('DateTimePicker').date hire_date.clone().subtract($('#app_days_to_fill').val(), 'days')
      p.on 'dp.change', (e)->
        $('#app_days_to_fill').val Math.abs(hire_date.clone().diff(e.date, 'days'))

      modal.find('#days_to_fill_done').on 'click', ->
        modal.modal 'hide'
        false

      modal.modal()
      false

  if $('#app_days_to_fill_input').length > 0
    activate_days_to_fill()

  $(document).on 'show.bs.modal', '.modal', ->
    if $(this).find('#hire_details_form').length > 0
      activate_days_to_fill()

)
